import React from "react";
import ProductTypes from "../../../../productTypes/productTypes";
import { CONFIGURATION } from "utilities/configuration";

export default function CreateQuoteStepFour(props) {
    const {
        data,
        events,
        handleAdditionalReq,
        submitGetQuote,
        handleQuoteOptionDelete,
        handleQuoteDeviationOptionDelete,
        setEditOption,
        setDeviationEditOption,
        setAddOption,
        reQuoteData,
        isReQuote
    } = props;
    const { currentStep } = data;

    if (currentStep !== CONFIGURATION.QUOTE_WIZARD_STEP_SUMMARY) {
        return null;
    }

    // console.log("Step3", data);

    return (
        <div className="row summary">
            <ProductTypes
                data={data}
                events={events}
                handleAdditionalReq={handleAdditionalReq}
                submitGetQuote={submitGetQuote}
                handleQuoteOptionDelete={handleQuoteOptionDelete}
                handleQuoteDeviationOptionDelete={handleQuoteDeviationOptionDelete}
                setEditOption={setEditOption}
                setDeviationEditOption={setDeviationEditOption}
                setAddOption={setAddOption}
                reQuoteData={reQuoteData}
                isReQuote={isReQuote}
            />
        </div>
    );
}